import { render, staticRenderFns } from "./ManageAbout.vue?vue&type=template&id=75f77642&scoped=true&"
import script from "./ManageAbout.vue?vue&type=script&lang=js&"
export * from "./ManageAbout.vue?vue&type=script&lang=js&"
import style0 from "./ManageAbout.vue?vue&type=style&index=0&id=75f77642&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f77642",
  null
  
)

export default component.exports